var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"product-item",attrs:{"href":'/#/SearchItemResult/' + _vm.item.id}},[_c('span',{staticClass:"product-item-name"},[_vm._v(_vm._s(_vm.item.name))]),_c('span',{staticClass:"product-item-code"},[_vm._v(_vm._s(_vm.item.code))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }